const UTARA_STATES = [
  {
    name: "KEDAH",
    values: [
      "SK LANAI",
      "SEKOLAH MENENGAH KEBANGSAAN BANDAR BARU SINTOK",
      "SEKOLAH KEBANGSAAN IBRAHIM",
      "SEKOLAH MENENGAH KEBANGSAAN TUNKU BENDAHARA",
      "SEKOLAH KEBANGSAAN MAHANG",
      "SMK DATO SYED OMAR",
      "SMJK SIN MIN",
      "SMK TANJONG PUTERI",
      "SEK KEB BATU PEKAKA ",
      "SEKOLAH KEBANGSAAN KAMPONG KEDA",
      "SEKOLAH MENENGAH KEBANGSAAN PADANG SERAI",
      "SK KUALA MERAH",
      "SK JUNJONG",
      "SEKOLAH KEBANGSAAN PADANG LUMAT",
      "SEKOLAH MENENGAH KEBANGSAAN KULIM",
      "SEKOLAH MENENGAH KEBANGSAAN TAMAN SELASIH",
      "SJKT MAHAJOTHI",
      "SEKOLAH MENENGAH SAINS PENDANG",
      "SK PINANG TUNGGAL",
      "SK SERI AMPANG MUDA",
      "SMK CHIO MIN",
      "SJKC CHOONG HWA",
      "SEKOLAH KEBANGSAAN KELADI",
      "SK AMBANGAN HEIGHTS SUNGAI PETANI",
      "SK CONVENT FATHER BARRE",
      "SJKT LADANG BATU PEKAKA",
      "SEKOLAH MENENGAH KEBANGSAAN SUNGAI LAYAR",
      "SMK JERAI",
      "SEKOLAH MENENGAH KEBANGSAAN AMAN JAYA",
      "SEKOLAH KEBANGSAAN CHEPIR",
      "SMK KUALA PEGANG",
      "SEKOLAH KEBANGSAAN PENDANG",
      "SEKOLAH MENENGAH KEBANGSAAN KOTA KUALA MUDA",
      "SMK SERI MAHAWANGSA",
      "SEKOLAH JENIS KEBANGSAAN (TAMIL) SARASWATHY",
      "SK KUALA PEGANG",
      "SJKT SOMASUNDRAM",
      "SEKOLAH KEBANGSAAN GUNUNG BONGSU",
      "SJKC CHIO MIN A",
      "SM PENDIDIKAN KHAS VOKASIONAL MERBOK",
      "SEKOLAH MENENGAH SAINS SULTAN MOHAMAD JIWA",
      "SEKOLAH MENENGAH KEBANGSAAN SEBERANG PERAK",
      "SEKOLAH KEBANGSAAN DATO' WAN MOHD SAMAN",
      "SEKOLAH KEBANGSAAN SUNGAI KARANGAN",
      "SEKOLAH KEBANGSAAN TIKAM BATU",
      "SK KAMPONG KEDA",
      "KOLEJ SULTAN ABDUL HAMID",
      "SEKOLAH RENDAH ISLAM NURUL HIDAYAH PENGHULU ELANG SABK",
      "SEKOLAH KEBANGSAAN LANGKAWI",
      "SEKOLAH KEBANGSAAN LANAI",
      "SK BAKAR ARANG",
      "SMK BATU LAPAN ",
      "SEKOLAH KEBANGSAAN TEMBAK",
      "SEKOLAH KEBANGSAAN ISKANDAR",
      "SEKOLAH JENIS KEBANGSAAN (CINA) YEANG CHENG",
      "SEKOLAH KEBANGSAAN ULU TAWAR",
      "SEKOLAH KEBANGSAAN MERBOK (PUSAT)",
      "SMK PENDANG",
      "SEKOLAH KEBANGSAAN KEDAWANG",
      "SEKOLAH MENENGAH KEBANGSAAN BANDAR PUTERI JAYA",
      "SEKOLAH JENIS KEBANGSAAN (CINA) YIH MIN",
      "SEKOLAH KEBANGSAAN GURUN (PUSAT)",
      "SK PADANG CHICHAK",
      "SMK PINANG TUNGGAL",
      "SJKT KULIM",
      "SEKOLAH MENENGAH KEBANGSAAN ALOR MERAH",
      "SMK TUNKU ABD. AZIZ",
      "SEKOLAH JENIS KEBANGSAAN (CINA) SIN MIN 'B'",
      "SEKOLAH KEBANGSAAN WAN ABDUL SAMAD",
      "SJKT LADANG WELLESLEY",
      "SMK TUNKU ABDUL RAHMAN",
      "SEKOLAH KEBANGSAAN LANGKASUKA",
      "SMK SULTANAH BAHIYAH",
      "SK SUNGAI KECHIL ILIR",
      "SMK IBRAHIM",
      "SMK YAN",
      "SJKT DARULAMAN",
      "SMK BANDAR BUKIT KAYU HITAM",
      "SEKOLAH KEBANGSAAN KUALA KEDAH",
      "SEKOLAH KEBANGSAAN SULTANAH ASMA",
      "SEKOLAH KEBANGSAAN TASEK APONG",
      "SK PADANG PEKAN",
      "SEKOLAH KEBANGSAAN ALOR JANGGUS",
      "SEKOLAH KEBANGSAAN DATO' WAN KEMARA",
      "SEKOLAH MENENGAH KEBANGSAAN JUNJUNG",
      "SK KILIM",
      "SEKOLAH KEBANGSAAN TUNKU ISMAIL",
      "SEKOLAH MENENGAH KEBANGSAAN KUBOR PANJANG",
      "SEKOLAH JENIS KEBANGSAAN (CINA) CHUNG HWA",
      "SMK PEDU",
      "SEKOLAH MENENGAH KEBANGSAAN TANJONG PUTERI",
      "SEKOLAH KEBANGSAAN PENDIDIKAN KHAS SUNGAI PETANI",
      "SMK HOSBA",
      "SMK GULAU",
      "SEKOLAH KEBANGSAAN BATU 8",
      "SEKOLAH MENENGAH AGAMA (ARAB) ANNAJAH",
      "SJKC KEAT HWA S",
      "SJKC TAI TONG",
      "SMK AGAMA JERLUN",
      "SMK PARIT PANJANG",
      "SEKOLAH KEBANGSAAN PENDIDIKAN KHAS ALOR SETAR",
      "SEKOLAH KEBANGSAAN PEREMBA",
      "SEKOLAH KEBANGSAAN JENERI",
      "SEKOLAH JENIS KEBANGSAAN (TAMIL) PALANISAMY KUMARAN",
      "SEKOLAH KEBANGSAAN BANDAR BARU DARULAMAN",
      "SEKOLAH KEBANGSAAN SELAT BAGAN NYIOR ",
      "SEKOLAH KEBANGSAAN SRI LIMAU",
      "SEKOLAH KEBANGSAAN TAMAN HI-TECH",
      "SMK SIK",
      "SEKOLAH KEBANGSAAN TUNKU PUTERA",
      "SEKOLAH JENIS KEBANGSAAN (CINA) KUALA KETIL",
      "SEKOLAH MENENGAH KEBANGSAAN DARUL AMAN HEIGHT 1",
      "SMK SERI ENGGANG",
      "SJKC KAMPUNG LALANG ",
      "SEKOLAH MENENGAH KEBANGSAAN TAMAN RIA JAYA",
      "SMK ST THERESA ",
      "SMK TAMAN MUTIARA",
      "SYED MOHAMED AL-BUKHARY ",
      "SMK TENGKU LAKSAMANA ",
      "SEKOLAH KEBANGSAAN TUNKU ABDUL RAHMAN PUTRA",
      "SMA SUNGAI PETANI",
      "SJKC SIN KWANG ",
      "SK KUALA TERIANG",
      "SEKOLAH KEBANGSAAN KUALA MERAH",
      "SK JALAN PEGAWAI ",
      "SJKC HWA MIN",
      "SEKOLAH KEBANGSAAN TUNKU INTAN SAFINAZ",
      "SK LUNAS JAYA",
      "SEKOLAH KEBANGSAAN GUAR LOBAK ",
      "SMA IRSYADIAH ",
      "SJKC CHEE NAN",
      "SJKC KEE CHEE",
      "SJKT LADANG SUNGAI RAYA",
      "SJKC PENG MIN",
      "SJKC CHIO MIN B",
      "SK SUNGAI LAYAR ",
      "SEKOLAH KEBANGSAAN ULU MELAKA",
      "MAAHAD TAHFIZ SAINS DARUL AMAN",
      "SMK TUNKU PUTERA",
      "MRSM BALING",
      "SEKOLAH KEBANGSAAN BUKIT PINANG",
      "MAKTAB MAHMUD LANGKAWI",
      "SEKOLAH KEBANGSAAN SYED SHEH",
      "SJKT LADANG HENRIETTA",
      "SK HUJUNG BANDAR",
      "SK SERI PINANG",
      "SK SERI NEGERI",
      "SMJK KEAT HWA",
      "SEKOLAH JENIS KEBANGSAAN (CINA) MIN NAM",
      "SEKOLAH KEBANGSAAN TAMAN KENARI",
      "SEKOLAH KEBANGSAAN SIONG",
    ],
  },
  {
    name: "PERAK",
    values: [
      "SEKOLAH KEBANGSAAN SUNGAI BULOH",
      "SK RAPAT SETIA ",
      "SEKOLAH KEBANGSAAN PANGKALAN TLDM II",
      "SK HAJI DAHALAN",
      "SEKOLAH MENENGAH KEBANGSAAN DATUK HJ ABD WAHAB",
      "SEKOLAH KEBANGSAAN KOTA SETIA",
      "SK BELURU",
      "SMK HUTAN MELINTANG",
      "SK HUTAN MELINTANG",
      "POLITEKNIK SULTAN AZLAN SHAH",
      "SEKOLAH KEBANGSAAN BESOUT 5",
      "SK BANGGOL JAS",
      "SEKOLAH KEBANGSAAN POS BERSIH",
      "SK BESOUT 4",
      "SK PANGKALAN TLDM",
      "SMK (F) BESOUT",
      "SJKT ENGGOR",
      "SEKOLAH JENIS KEBANGSAAN (TAMIL) LADANG SUNGAI KRUIT",
      "SEKOLAH KEBANGSAAN SUNGAI KELI",
      "SK TANAH LALANG",
      "SEKOLAH MENENGAH KEBANGSAAN AYER TAWAR",
      "SEKOLAH KEBANGSAAN SUNGAI NIPAH",
      "SK POS TENAU",
      "SMK KG DATO SERI KAMARUDDIN",
      "SEKOLAH JENIS KEBANGSAAN TAMIL KERUH",
      "SMK DINDINGS",
      "SEKOLAH KEBANGSAAN RUNGKUP",
      "SJKT MAHATHMA GANDHI KALASALAI",
      "SK SLIM VILLAGE",
      "SMK RAPAT SETIA",
      "SK SERI ISKANDAR PERAK",
      "SMK METHODIST ACS SITIAWAN PERAK ",
      "SK BATU TIGA ",
      "SJKT SLIM RIVER",
      "SEKOLAH MENENGAH SAINS TELUK INTAN",
      "SK SELEKOH",
      "SEKOLAH JENIS KEBANGSAAN (CINA) KHUEN HEAN",
      "SMK JALAN TASEK",
      "SEKOLAH KEBANGSAAN KOTA 6",
      "SEKOLAH KEBANGSAAN KAMPUNG BAHARU",
      "SMK DATO' PANGLIMA PERANG KIRI TAPAH ROAD PERAK ",
      "SK TITI GANTONG",
      "SMK AMINUDDIN BAKI ",
      "SJKT LADANG CHEMOR ",
      "KOLEJ VOKASIONAL SLIM RIVER",
      "SMK KHIR JOHARI TANJONG MALIM",
    ],
  },
  {
    name: "PERLIS",
    values: [
      "SMA AL-MADRASAH AL-ALAWIYAH AD-DINIAH ",
      "SK TAMBUN TULANG ",
      "SK LONG BOH ",
      "SMA AL MADRASAH AL ALAWIYAH AD DINIAH",
      "SK CHANGKAT JAWI",
      "SEKOLAH MENENGAH KEBANGSAAN SYED AHMAD",
    ],
  },
  {
    name: "PULAU PINANG",
    values: [
      "KOLEJ VOKASIONAL BATU LANCHANG",
      "SK CONVENT BUTTERWORTH",
      "SEKOLAH MENENGAH KEBANGSAAN UNION",
      "SJKC TRUE LIGHT ",
      "SEKOLAH KEBANGSAAN PADANG TEMBAK",
      "SMK PENANTI",
      "SK JELUTONG BARAT",
      "SEKOLAH KEBANGSAAN MUTIARA PERDANA",
      "SEKOLAH JENIS KEBANGSAAN (CINA) HENG EE",
      "SMJK HENG EE",
      "SEKOLAH MENENGAH KEBANGSAAN PHOR TAY",
      "SEKOLAH MENENGAH KEBANGSAAN TELOK KUMBAR",
      "SMK DATUK HAJI AHMAD BADAWI",
      "SJKC KWANG HWA",
      "SMJK UNION ",
      "SEKOLAH MENENGAH SAINS TUN SYED SHEH SHAHABUDDIN",
      "SEKOLAH MENENGAH KEBANGSAAN CHUNG LING BUTTERWORTH",
      "SMJK UNION",
      "SJKC HAN CHIANG",
      "SMKA (L) AL-MASHOOR",
      "SK SUNGAI NIBONG",
      "SK SERI PENANTI",
      "SEKOLAH JENIS KEBANGSAAN (CINA) KENG KOON",
      "SMKA AL-IRSHAD",
      "SMK DATUK HAJI AHMAD SAID",
      "SJKC CHONG TEIK",
      "SEKOLAH KEBANGSAAN SG NIBONG",
      "SEKOLAH JENIS KEBANGSAAN (CINA) LI TEK CAWANGAN",
      "SEKOLAH JENIS KEBANGSAAN (CINA) HAN CHIANG",
      "SK TASEK PERMAI ",
      "SK POKOK SENA",
      "SK BUKIT GAMBIR",
      "SK DESA MURNI ",
      "SEKOLAH KEBANGSAAN BERTAM PUTRA",
      "SEKOLAH MENENGAH KEBANGSAAN CONVENT DATUK KERAMAT",
      "SMK PERMAI INDAH",
      "SK SERI IMPIAN",
      "SK STOWELL",
      "SJKC YANG CHENG",
      "SEKOLAH KEBANGSAAN SUNGAI DUA",
      "SEKOLAH KEBANGSAAN BATU KAWAN",
      "SMK TELOK KUMBAR",
      "SJKC BENG TEIK CAWANGAN",
      "SMK (P) METHODIST",
      "SEKOLAH MENENGAH KEBANGSAAN DATUK HAJI AHMAD BADAWI",
      "SJKT SUNGAI BAKAP",
    ],
  },
];

const TENGAH_STATES = [
  {
    name: "SELANGOR",
    values: [
      "ez cute robots",
      "SEKOLAH KEBANGSAAN USJ 2",
      "SMK SEKSYEN 1 BANDAR KINRARA PUCHONG",
      "SK TAMAN PUTERI",
      "SEVEN SKIES INTERNATIONAL SCHOOL",
      "SK BAGAN TERAP",
      "SK TAMAN EHSAN",
      "SK BANDAR BARU BANGI",
      "SMK BANDAR BARU SALAK TINGGI",
      "SEKOLAH KEBANGSAAN DAMANSARA DAMAI 1",
      "SK SERI SEKINCHAN",
      "SEKOLAH MENENGAH SAINS BANTING",
      "SMK TAMAN SRI MUDA",
      "SEKOLAH MENENGAH ISLAM AL-AMIN GOMBAK",
      "SMK SERI KUNDANG",
      "SMK SIERRAMAS ",
      "SMK BANDAR BARU BATANG KALI",
      "SMK JALAN EMPAT",
      "SEKOLAH KEBANGSAAN HULU BERNAM",
      "SK SG LIMAU",
      "SJKT WEST COUNTRY(TIMUR)",
      "SMK TAMAN MELAWATI",
      "SEKOLAH KEBANGSAAN CYBERJAYA",
      "SEKOLAH MENENGAH KEBANGSAAN TAMAN BUNGA RAYA (1)",
      "SMK SUNGAI PUSU",
      "SEKOLAH KEBANGSAAN SUNGAI KANTAN",
      "SJKC KIAN SIT ",
      "SK TEBOK JAWA",
      "SMK SEKSYEN 7",
      "SK TAMAN TUN DR ISMAIL JAYA",
      "SK BUKIT KEMUNING 2",
      "SMK (P) TAMAN PETALING",
      "SK DOKTOR ABDUL LATIFF",
      "SMK TAMAN TASIK",
      "SEKOLAH JENIS KEBANGSAAN (TAMIL) LADANG SABAK BERNAM",
      "SEKOLAH MENENGAH KEBANGSAAN SERI SERDANG",
      "SMK SEKSYEN 16",
      "SK TAMAN BUNGA RAYA 2",
      "SMK SERENDAH",
      "SEKOLAH KEBANGSAAN KHIR JOHARI",
      "SK SEKSYEN ENAM",
      "SEKOLAH KEBANGSAAN BATU 38 ",
      "SEKOLAH KEBANGSAAN BANDAR TUN HUSSEIN ONN 2",
      "SMJK KWANG HUA",
      "SMK SELAYANG BHARU",
      "SMK SYED MASHOR",
      "SMK BANDAR SUNGAI BUAYA ",
      "SEKOLAH JENIS KEBANGSAAN (CINA) UNION",
      "SJKC PHOOI MIN ",
      "SK CYBERJAYA",
      "SEKOLAH KEBANGSAAN BANDAR SUNGAI BUAYA",
      "SEKOLAH RENDAH AGAMA INTEGRASI TAMAN KERAMAT",
      "SK TELUK RU",
      "SMK USJ 13 ",
      "SK SUNGAI KANTAN",
      "SEKOLAH KEBANGSAAN BUKIT RAHMAN PUTRA",
      "SK PARIT 6 ",
      "SK TAMAN MEGAH",
      "SK SS 19 SUBANG JAYA",
      "SEKOLAH MENENGAH KEBANGSAAN SUNGAI PUSU",
      "SEKOLAH MENENGAH KEBANGSAAN TAMAN SRI MUDA",
      "SMK BANDAR TUN HUSSEIN ONN 2",
      "SK TUN DOKTOR ISMAIL",
      "SEKOLAH KEBANGSAAN GOMBAK UTARA",
    ],
  },
  {
    name: "WILAYAH PERSEKUTUAN KUALA LUMPUR",
    values: [
      "SMK TAMAN DESA KL",
      "SK JALAN GURNEY 2",
      "SEKOLAH KEBANGSAAN BANDAR TUN RAZAK 1",
      "SEKOLAH KEBANGSAAN JALAN PEEL",
      "SMK BANDAR TASIK SELATAN",
      "SEKOLAH KEBANGSAAN LA SALLE (1) SENTUL",
      "SEKOLAH KEBANGSAAN POLIS DEPOT",
      "SMJK CHONG HWA KL",
      "SK CONVENT (2) BUKIT NANAS",
      "SMK SEGAMBUT JAYA ",
      "SMK SERI SAUJANA",
      "SMK SERI TASIK",
      "SJK(C) ST. TERESA",
      "ST. JOHN'S INSTITUTION ",
      "SK BANDAR TASIK SELATAN",
      "SJKT JALAN FLETCHER",
      "SEKOLAH MENENGAH TEKNIK KUALA LUMPUR",
      "SK LA SALLE 2 JINJANG ",
      "SK ST TERESA BRICKFIELDS 1(M)",
      "SMK AGAMA KUALA LUMPUR",
      "SMK SEGAMBUT JAYA",
      "SJKT VIVEKANANDA",
      "SEKOLAH MENENGAH AGAMA ",
      "SEKOLAH MENENGAH KEBANGSAAN TAMAN BUKIT MALURI",
      "SJKC KWONG HON",
      "SEKOLAH JENIS KEBANGSAAN (TAMIL) JLN SAN PENG",
      "SK DESA PANDAN",
      "SK JALAN PASAR 1",
      "SEKOLAH MENENGAH KEBANGSAAN TAMAN SETIAWANGSA",
      "SJKT LADANG EDINBURGH",
      "SEKOLAH JENIS KEBANGSAAN (TAMIL) CHERAS",
      "SEKOLAH KEBANGSAAN SERI SURIA",
      "SEKOLAH KEBANGSAAN JALAN BELLAMY",
      "SK PENDIDIKAN KHAS KG BAHARU",
      "SEKOLAH KEBANGSAAN PUTERI PANDAN 2",
      "SEKOLAH MENENGAH KUEN CHENG",
      "SMK (P) BANDARAYA",
      "SK SERI MURNI",
      "SEKOLAH KEBANGSAAN TAMAN SEGAR",
      "SMK SERI BINTANG SELATAN",
      "QUEENSVILLE INTEGRATED ISLAMIC SCHOOL",
      "SMK SERI BINTANG UTARA",
      "SJKC TAI THUNG ",
      "SEKOLAH KEBANGSAAN DATOK KERAMAT 1",
      "SEKOLAH KEBANGSAAN DESA SETAPAK",
      "SK WANGSA JAYA",
      "SMK WANGSA MAJU SEKSYEN 2",
      "SEKOLAH KEBANGSAAN DESA PANDAN",
      "SMK BUKIT BANDARAYA",
    ],
  },
  {
    name: "WILAYAH PERSEKUTUAN PUTRAJAYA",
    values: ["SK PUTRAJAYA PRESINT 18(1)", "SK PUTRAJAYA PRESINT 9(1)"],
  },
];

const TIMUR_STATES = [
  {
    name: "KELANTAN",
    values: [
      "SK SULTAN IBRAHIM 3 ",
      "SMK BAROH PIAL",
      "SEKOLAH KEBANGSAAN BERIS KUBOR BESAR",
      "KOLEJ VOKASIONAL PASIR MAS",
      "SMK TENDONG ",
      "SMK BUNUT SUSU",
      "SMK KEROH",
      "SMK KANDIS",
      "SEKOLAH KEBANGSAAN KANGKONG",
      "SK RANTAU PANJANG",
      "SEKOLAH MENENGAH KEBANGSAAN BANDAR CHIKU",
      "SEKOLAH KEBANGSAAN LUBOK SETOL",
      "SEKOLAH KEBANGSAAN BATU GAJAH",
      "SEKOLAH KEBANGSAAN PASIR GAJAH ",
      "SMK PALOH",
      "SEKOLAH KEBANGSAAN LANGGAR",
      "SMK BADAK",
      "SEKOLAH KEBANGSAAN KUALA GERIS",
      "SK KULIM",
      "SMK SULTAN YAHYA PETRA 1",
      "SEKOLAH KEBANGSAAN PAHI",
      "SK SRI WANGI 2",
      "SMK DABONG",
      "SEKOLAH KEBANGSAAN KAMPONG BEDAL",
      "SEKOLAH KEBANGSAAN JELAWAT 2",
      "SJKC YUK CHAI",
      "SK SG SAM",
      "SEKOLAH KEBANGSAAN MEKASAR",
      "SK BUKIT JAWA",
      "SJKC KAI CHIH",
      "SK SRI SURIA 1  ",
      "SEKOLAH KEBANGSAAN KAMPONG CHAP",
      "SK BUKIT JAWA 2",
      "SEKOLAH KEBANGSAAN DABONG",
      "SMKA FALAHIAH",
      "MAAHAD SYAMSUL MAARIF LELAKI ",
      "SEKOLAH KEBANGSAAN SULTAN YAHYA PETRA(1)",
      "MAAHAD PENGAJIAN ISLAM ",
      "SK TELKONG ",
      "SK. KAMPONG BERANGAN",
    ],
  },
  {
    name: "PAHANG",
    values: [
      "SEKOLAH KEBANGSAAN TEH",
      "SMK LEPAR UTARA",
      "SMK PAYA PULAI",
      "SMK KATHOLIK",
      "SEKOLAH MENENGAH KEBANGSAAN SERI BENTONG",
      "SEKOLAH MENENGAH KEBANGSAAN (FELDA) LURAH BILUT",
      "SK KAMPONG TENGAH",
      "MRSM KUANTAN",
      "SMK PADANG TENGKU",
      "SEKOLAH MENENGAH KEBANGSAAN KARAK SETIA",
      "SK MAT KILAU",
      "SEKOLAH KEBANGSAAN JAMBU RIAS",
      "SEKOLAH KEBANGSAAN SULAIMAN",
      "SJKC JERIK",
      "SEKOLAH KEBANGSAAN JERANTUT JAYA",
      "SK MEMPAGA 1",
      "SEKOLAH KEBANGSAAN MELATI",
      "SEKOLAH MENENGAH KEBANGSAAN SULAIMAN",
      "SEKOLAH KEBANGSAAN TUANKU FATIMAH",
      "SMK KHAI MUN",
      "SK FELDA MEMPAGA 2",
      "SMK KEMAYAN ",
      "SEKOLAH KEBANGSAAN TUNKU AZIZAH",
      "SEKOLAH MENENGAH KEBANGSAAN SERI PELANGAI",
      "SMK KETARI",
      "SMK BENTONG",
      "MRSM BENTONG",
      "SMK SULTANAH HAJJAH KALSOM ",
      "SEKOLAH KEBANGSAAN KARAK",
      "SK SUNGAI MARONG",
      "SEKOLAH KEBANGSAAN BUKIT PIATU",
      "SEKOLAH KEBANGSAAN LEBU",
      "SEKOLAH MENENGAH AGAMA PERSEKUTUAN BENTONG",
      "SK JAMBU RIAS",
      "SEKOLAH KEBANGSAAN TERUNTUM ",
      "SEKOLAH KEBANGSAAN KG SHAFIE",
      "SEKOLAH MENENGAH KEBANGSAAN KUALA REPAS",
      "SK FELDA LURAH BILUT ",
      "SEKOLAH MENENGAH KEBANGSAAN (FELDA) PURUN",
    ],
  },
  {
    name: "TERENGGANU",
    values: [
      "SMK CHUNG HWA WEI SIN",
      "SEKOLAH KEBANGSAAN CHUKAI",
      "SJKC CHUNG HWA JERTEH",
      "SEKOLAH KEBANGSAAN PENDIDIKAN KHAS KUALA TERENGGANU",
      "SMK KOMPLEKS MENGABANG TELIPOT",
      "SMK BINJAI",
      "SK KUALA BESUT",
      "SJK C CHUNG HWA",
      "SK BINJAI KERTAS",
      "SK DURIAN BURING",
      "SMK TENGKU MIZAN ZAINAL ABIDIN",
      "SK KELULUT",
      "SMKA DURIAN GULING",
      "SK KETENGAH JAYA II",
      "SK SAUJANA",
      "SMK SERI PAYONG",
      "SMK KOMPLEKS GONG BADAK",
      "SEKOLAH MENENGAH KEBANGSAAN BUKIT MENTOK",
      "SEKOLAH KEBANGSAAN AYER PUTEH",
      "SMK CANOSSA CONVENT (M)",
      "SK KUALA KEMAMAN",
      "SEKOLAH KEBANGSAAN TELUK KETAPANG",
      "SK TENGKU AMPUAN MARIAM",
      "SEKOLAH MENENGAH KEBANGSAAN GELIGA",
      "SMK SULTAN ISMAIL",
    ],
  },
];

const SELATAN_STATES = [
  {
    name: "JOHOR",
    values: [
      "SMK PALOH JOHOR",
      "SEKOLAH KEBANGSAAN KAMPUNG MAJU JAYA",
      "SK KOMPLEKS SULTAN ABU BAKAR",
      "SMK LABIS",
      "SK LKTP BATU 27",
      "SMK CONVENT BATU PAHAT",
      "SMK MUNSHI IBRAHIM",
      "SK MELAYU RAYA SEGAMAT",
      "SMK AGAMA SEGAMAT",
      "SEKOLAH MENENGAH KEBANGSAAN MUTIARA RINI",
      "SK PENGHULU SALLEH ",
      "KOLEJ VOKASIONAL MUAR",
      "SMK KAMARUL ARIFFIN",
      "SMK TAMAN SELESA JAYA 2",
      "SEKOLAH KEBANGSAAN KULAI",
      "SEKOLAH KEBANGSAAN BANANG JAYA",
      "SK KAMPONG JAWA",
      "SMK TUN ISMAIL",
      "SMK INFANT JESUS CONVENT JOHOR BAHRU ",
      "SMK BANDAR TENGGARA 2",
      "SEKOLAH JENIS KEBANGSAAN (CINA) NAM HENG BARU",
      "SK LKTP MAOKIL 1",
      "SMK SERI PERDANA",
      "SMK TAMAN MUTIARA RINI 2",
      "SK PEKAN BAHARU MUAR",
      "SEKOLAH KEBANGSAAN TAMAN PELANGI INDAH",
      "KOLEJ VOKASIONAL TANJUNG PUTERI",
      "SK SERI PANTAI",
      "SK SEGAMAT BARU",
      "SEKOLAH KEBANGSAAN TAMAN DAMANSARA ALIFF",
      "SMK BANDAR T6",
      "SK JEMENTAH",
      "SEKOLAH MENENGAH PENDIDIKAN KHAS VOKASIONAL INDAHPURA",
      "SEKOLAH KEBNGSAAN LKTP MAOKIL1",
      "SMK MEDINI",
      "SK BUKIT RAHMAT",
      "SEKOLAH KEBANGSAAN TAMAN KOTA KULAI 2",
      "SK SERI BENGKAL",
      "SK SUNGAI BUNYI",
      "SMK SERI TANGKAK",
      "SJKC KAMPUNG GAJAH",
      "SK KAMPONG JAWA",
      "SMK SERI LALANG",
      "SMJK SEG HWA",
      "SEKOLAH MENENGAH KEBANGSAAN SENGGARANG",
      "SMK SKUDAI",
      "SK PARIT KUDUS",
      "SEKOLAH KEBANGSAAN TAMAN IMPIAN EMAS",
      "SJK T JALAN HAJI MANAN",
      "SMK SULTANAH ENGKU TUN AMINAH",
      "SMK TUNKU PUTRA",
      "SK (P) SULTAN IBRAHIM",
      "SEKOLAH KEBANGSAAN INFANT JESUS CONVENT JOHOR BAHRU",
      "SMK TMN KLUANG BARAT",
      "SEKOLAH KEBANGSAAN TAMAN CENDANA",
      "SEKOLAH MENENGAH KEBANGSAAN DATO' BENTARA DALAM",
      "SEKOLAH SENI MALAYSIA JOHOR",
      "SJK (C) PULAI",
      "SK TAMAN CENDANA",
      "SEKOLAH KEBANGSAAN BUKIT HAMPAR",
      "SEKOLAH KEBANGSAAN (FELDA) ULU PENGGELI",
      "SMK SRI MERSING",
      "SEKOLAH KEBANGSAAN DATUK WAN IDRIS",
      "SM SAINS JOHOR KLUANG",
      "SK TEMIANG ",
      "SK SRI LABIS",
      "SMK DATO' HAJI HASSAN YUNOS",
      "SEKOLAH KEBANGSAAN LKTP MAOKIL 1",
      "SMK SURIA PERDANA ",
      "SEKOLAH KEBANGSAAN TAMAN SCIENTEX",
      "SEKOLAH MENENGAH KEBANGSAAN TAMAN RINTING 2",
      "SMK DATO' SYED ESA",
      "SEKOLAH MENENGAH KEBANGSAAN SULTAN ISMAIL",
      "SK PEKAN BAHARU",
      "SMK BANDAR PUTRA KULAI",
      "SMK PASIR GUDANG 2",
      "SEKOLAH KEBANGSAAN SERI PENGKALAN",
      "SMK SERI KENANGAN SEGAMAT",
      "SMK TAMAN DAMANSARA ALIFF",
      "SK FELCRA SUNGAI ARA",
      "SK SERI PADANG SARI",
      "SMK TAMAN RINTING 2",
      "SK JALAN YUSOF",
      "SEKOLAH KEBANGSAAN TAMAN RINTING 3",
      "SEKOLAH KEBANGSAAN LKTP AYER HITAM",
      "SK SERI BUKIT BATU",
      "SJKC LEE MING",
      "SMK (P) TEMENGGONG IBRAHIM ",
      "SEKOLAH KEBANGSAAN BANDAR TENGGARA 1",
      "SK SRI SKUDAI",
      "SK TAMAN DAYA 2",
      "SK LENGA",
      "SEKOLAH KEBANGSAAN FELCRA SUNGAI ARA",
      "SK BUKIT KENANGAN ",
      "SK SUNGAI TELOR",
      "SJKC TUNG CHENG",
      "SEKOLAH KEBANGSAAN TAMAN UNIVERSITI 1",
      "SK KG DATO IBRAHIM MAJID",
      "SEKOLAH KEBANGSAAN SEPINANG",
      "SEKOLAH KEBANGSAAN TG KUPANG",
      "SK KAMPONG MELAYU",
      "SMK INDAHPURA (1)",
      "S.K. BANDAR",
      "SJK(T) LADANG RINI",
      "SK MORNI POK",
      "SK SRI TEBRAU",
      "SMK TENGKU ARIS BENDAHARA",
      "SMK BANDAR PUTRA 2",
      "SEKOLAH KEBANGSAAN SIMPANG JERAM",
      "SK TANJUNG KUPANG",
      "SEKOLAH MENENGAH KEBANGSAAN SENAI",
      "SEKOLAH KEBANGSAAN SRI AMAR",
      "SK LIMPOON 1",
      "SEK KEB SAINT JOSEPH",
      "SEKOLAH JENIS KEBANGSAAN (CINA) SENGKANG",
      "SJK(C) CHEE TONG",
      "SMK BANDAR TENGGARA ",
      "SK TAMAN MUTIARA RINI",
      "SEKOLAH KEBANGSAAN MASAI",
      "SK TAMAN TUN AMINAH",
      "SK PENYABONG",
      "SMK SIMPANG RENGAM",
      "SMK(P) SULTAN ABU BAKAR",
      "SK BANDAR PUTRA",
      "SEKOLAH KEBANGSAAN JEMENTAH",
      "SMK TINGGI BATU PAHAT ",
      "SK TELOK HUTAN LESONG",
      "SEKOLAH KEBANGSAAN PINTAS PUDING",
      "SEKOLAH MENENGAH KEBANGSAAN AIR TAWAR",
      "MRSM JOHOR BAHRU",
      "SK TAMAN DAMANSARA ALIFF",
      "SMK TAMAN DAMANSARA ALIFF ",
      "SEKOLAH KEBANGSAAN TEMENGGONG ABDUL RAHMAN",
      "SK PASIR GUDANG 2",
      "SMK TUNKU ABDUL RAHMAN PUTRA",
      "SK LADANG BUKIT BENUT",
      "SK TANJONG ADANG",
      "SK BANDAR MAHARANI",
      "SK SERI BEKOK",
      "SK (FELDA) LAYANG-LAYANG",
      "SMK TUN HABAB ",
      "SEKOLAH MENENGAH KEBANGSAAN TAMAN TUN AMINAH",
      "SMK ADELA",
      "SEKOLAH MENENGAH KEBANGSAAN SUNGAI TIRAM",
      "SK BANANG JAYA",
    ],
  },
  {
    name: "MELAKA",
    values: [
      "SEKOLAH KEBANGSAAN BUKIT CHINA",
      "SK METHODIST ACS",
      "SK MALIM",
      "SK DATUK TAMBICHIK KARIM",
      "SEKOLAH KEBANGSAAN KUALA LINGGI",
      "SEKOLAH KEBANGSAAN JASIN ",
      "SK KESANG TUA",
      "SEKOLAH KEBANGSAAN SEMPANG",
      "SEKOLAH KEBANGSAAN BELIMBING DALAM",
      "SEKOLAH KEBANGSAAN PERINGGIT",
      "SEKOLAH KEBANGSAAN MERLIMAU",
      "SK AYER LIMAU",
      "SMK DATO' ABDUL RAHMAN YA'KUB",
      "SJKC PAY CHEE",
      "SJKC SIMPANG BEKOH",
      "SEKOLAH JENIS KEBANGSAAN (CINA) YU YING",
      "SEKOLAH KEBANGSAAN KUBU",
      "SEKOLAH KEBANGSAAN PADANG SEBANG",
      "SJK(T) MELAKA (KUBU)",
      "SK SUNGAI TUANG",
      "SMK GHAFAR BABA",
      "SEKOLAH KEBANGSAAN SERI BANDAR",
      "SK SUNGAI PETAI",
      "SJKC CHUNG HWA",
      "SJKC JASIN LALANG ",
      "SJKC CHENG",
      "SMK TELOK MAS",
      "SM SAINS MUZAFFAR SYAH",
      "SMK TINGGI ST DAVID ",
      "SEKOLAH MENENGAH KEBANGSAAN LUBOK CHINA",
      "SK CHINCHIN ",
      "SEKOLAH KEBANGSAAN JUS",
      "SJKC PAY YAP ",
      "SEKOLAH MENENGAH KEBANGSAAN MALIM",
      "SK LIMBONGAN ",
      "SK RAMUAN CHINA BESAR",
      "SMA JAIM AL-ASYRAF",
      "SEKOLAH JENIS KEBANGSAAN (CINA) SIN MIN",
      "SMK DURIAN TUNGGAL",
      "SK BUKIT LINTANG ",
      "SEKOLAH KEBANGSAAN PAYA REDAN",
      "SMK TUN TIJAH",
      "SK  LESONG BATU",
      "SMK KRUBONG",
      "SEKOLAH JENIS KEBANGSAAN (CINA) MACHAP UMBOO",
      "SJKC YOK SIN ",
      "SK BUKIT LINTANG",
      "SK JALAN DATUK PALEMBANG BUKIT BARU MELAKA",
      "SK TENGKERA 1",
      "SK KEM GERAKHAS",
      "SEKOLAH JENIS KEBANGSAAN (CINA) PAY FONG 2",
      "SEKOLAH KEBANGSAAN PEGOH",
      "SMK SULTAN ALAUDDIN",
      "SK CHENDERAH",
      "SJKC MASJID TANAH",
      "SK CONVENT INFANT JESUS (2)",
      "SMK TEBONG",
      "SJKC PARIT KELILING",
      "SEKOLAH KEBANGSAAN TELOK MAS",
      "SJKC YING CHYE",
      "SMK MUNSHI ABDULLAH",
      "SJKC KUANG HWA",
      "SJKC ST MARY",
      "SJKC EK TE",
      "SJKC POH LAN ",
      "SK PANTAI KUNDOR",
      "SEKOLAH MENENGAH KEBANGSAAN GAJAH BERANG",
      "SMK DANG ANUM",
      "SK BUKIT BERINGIN",
      "SEKOLAH KEBANGSAAN JERAM",
      "SEKOLAH MENENGAH KEBANGSAAN DATO' HAJI TALIB KARIM",
      "SK TEBONG",
      "SEKOLAH JENIS KEBANGSAAN (CINA) SANN YUH",
      "SEKOLAH MENENGAH KEBANGSAAN KEM TERENDAK",
      "SK TANGGA BATU",
      "SMK TINGGI PEREMPUAN MELAKA",
      "SEKOLAH JENIS KEBANGSAAN (CINA) PAYA MENGKUANG",
      "SK ST. FRANCIS",
      "SJKC PAY CHUIN",
      "SMK PERNU",
      "SJK (C) MERLIMAU",
      "SEKOLAH KEBANGSAAN DATO' NANING",
      "SEKOLAH KEBANGSAAN CHENDERAH",
      "SEKOLAH MENENGAH KEBANGSAAN NYALAS",
      "SEKOLAH JENIS KEBANGSAAN (CINA) KEMENDOR",
      "SEKOLAH KEBANGSAAN TEDONG",
      "SK (P) METHODIST 1",
      "SJKC KIOW MIN",
      "SJKC YOK SIN",
      "SJKC BUKIT BERUANG ",
      "SEKOLAH MENENGAH KEBANGSAAN DATO' ABDUL RAHMAN YA'KUB",
      "SJKC PAY HWA",
      "SMK TINGGI PEREMPUAN",
      "SJK T BATANG MELAKA",
      "SJKC KATHOLIK",
      "SEKOLAH KEBANGSAAN DEMANG TAHA",
      "SK LIMBONGAN",
      "SK PAYA RUMPUT",
      "SMK DATO HAJI TALIB KARIM",
      "SMK AIR MOLEK",
      "SEKOLAH KEBANGSAAN ALOR GAJAH 1",
      "SEKOLAH KEBANGSAAN AYER MOLEK",
      "SK RAMUAN CHINA KECHIL ",
      "SJKT ALOR GAJAH",
      "SEKOLAH JENIS KEBANGSAAN CINA KIOW MIN",
      "SEKOLAH MENENGAH KEBANGSAAN SERI PENGKALAN",
      "SMK BUKIT BARU",
      "SJKC PAYA MENGKUANG ",
      "SEKOLAH MENENGAH KEBANGSAAN ADE PUTRA",
      "SJKC BACHANG",
      "SMK BUKIT BARU ",
      "SJKC WEN HUA",
      "SJKC SIN WAH",
      "SMK DATO' DOL SAID",
      "SK KAMPUNG TUN RAZAK",
      "SJKC PAY FONG 3",
      "SEKOLAH RENDAH ARAB JAIM BATANG TIGA TIMUR",
      "SJKC TOON HUA",
      "SK OTHMAN SHAWAL",
      "SK DEMANG TAHA",
      "SK SEBATU ",
      "SkK SERKAM DARAT",
      "SJKC YU HWA ",
      "SEKOLAH MENENGAH KEBANGSAAN BUKIT KATIL",
      "SEKOLAH MENENGAH KEBANGSAAN SUNGAI RAMBAI",
      "SJKC PING MING",
      "SEKOLAH KEBANGSAAN LIMBONGAN",
      "SK PARIT GANTONG",
      "SEKOLAH KEBANGSAAN CHINCHIN",
      "SJKC BERTAM ULU",
      "SEKOLAH MENENGAH KEBANGSAAN KRUBONG",
      "SBP INTEGRASI SELANDAR",
      "SMK KATHOLIK MELAKA",
      "SMKA SULTAN MUHAMMAD",
      "SEKOLAH JENIS KEBANGSAAN (CINA) CHIAO CHEE",
      "SEKOLAH KEBANGSAAN TEHEL",
      "SEKOLAH KEBANGSAAN ASAHAN",
      "SJKC PAY CHIAO",
      "SEKOLAH MENENGAH KEBANGSAAN AIR MOLEK",
      "SEKOLAH MENENGAH KEBANGSAAN TUN TUAH",
      "SEKOLAH MENENGAH KEBANGSAAN TINGGI ST DAVID",
      "SEKOLAH KEBANGSAAN KEM TERENDAK 1",
      "SEKOLAH MENENGAH KEBANGSAAN DURIAN TUNGGAL",
      "SMK SERI MAHKOTA",
      "SK BUKIT RAMBAI",
      "SJKC SHUH YEN",
      "SJKC AYER KEROH",
      "SMK PADANG TEMU",
      "SEKOLAH KEBANGSAAN SERI MENDAPAT",
      "SJKC SUNGAI UDANG",
      "SEKOLAH MENENGAH KEBANGSAAN RAHMAT",
      "SK LIMBONGAN",
      "SMA AL-EHYA AL-KARIM",
      "SK CHENDERAH ",
      "SK TAMAN BUKIT RAMBAI",
      "SEKOLAH MENENGAH KEBANGSAAN BUKIT RAMBAI",
      "SEKOLAH KEBANGSAAN TEBONG",
      "SEKOLAH KEBANGSAAN MELEKEK",
      "SJK T LADANG DIAMOND JUBILEE",
      "SJKT DURIAN TUNGGAL",
      "SEKOLAH KEBANGSAAN TANGGA BATU ",
      "SJKT JASIN",
      "SJKC YOK BIN",
      "SEKOLAH MENENGAH KEBANGSAAN HANG KASTURI",
      "SEKOLAH KEBANGSAAN HUTAN PERCHA",
      "SEKOLAH JENIS KEBANGSAAN (TAMIL) JASIN",
      "SEKOLAH KEBANGSAAN PADANG TEMU",
      "SEKOLAH JENIS KEBANGSAAN (TAMIL) BUKIT LINTANG",
      "SMK AYER KEROH",
      "SEKOLAH KEBANGSAAN BATU BERENDAM 2",
      "SJKC ALOR GAJAH",
      "SJKC KIOW MIN ",
      "SJKC KEMENDOR",
      "SEKOLAH MENENGAH KEBANGSAAN SIMPANG BEKOH",
      "SMJK YOK BIN",
      "SMK BUKIT KATIL ",
      "SK SERKAM ",
      "SMK NOTRE DAME CONVENT",
      "SK CHOHONG",
      "SEKOLAH JENIS KEBANGSAAN (CINA) PAY TECK",
      "SJK(T) PULAU SEBANG",
      "SK DUYONG MELAKA ",
      "SEKOLAH KEBANGSAAN KAMPUNG TUN RAZAK",
      "SEKOLAH KEBANGSAAN PAYA DALAM",
      "SMK TUN HAJI ABDUL MALEK",
      "SMKA TUN PERAK",
      "SK DATO' DEMANG HUSSIN",
      "SEKOLAH KEBANGSAAN PERNU",
      "SK KAMPUNG TUN RAZAK ",
      "SJK(T) PAYA RUMPUT",
      "SEKOLAH KEBANGSAAN BATANG MELAKA",
      "SEKOLAH KEBANGSAAN SRI LAKSAMANA",
      "SMK PULAU SEBANG",
      "SJKC ON LOK",
      "SEKOLAH MENENGAH KEBANGSAAN CANOSSA CONVENT ( M )",
      "SEKOLAH KEBANGSAAN PARIT GANTONG",
      "SJKC YU HSIEN",
      "SRA JAIM PERNU ",
      "SJKC TING HWA",
      "SK TANGGA BATU",
      "SMK NANING",
      "SK RAMUAN CHINA KECHIL",
      "SEKOLAH KEBANGSAAN PULAI",
      "SEKOLAH KEBANGSAAN MASJID BARU",
      "SEKOLAH JENIS KEBANGSAAN (CINA) SIANG LIN",
      "SEKOLAH KEBANGSAAN DUYONG",
      "SEKOLAH KEBANGSAAN LEREH",
      "SK BUKIT TEMBAKAU",
      "SMJK PULAU SEBANG",
      "SMK DATO'' ABDUL RAHMAN YA'KUB",
      "SK TERENTANG",
      "SEKOLAH KEBANGSAAN AIR JERNIH",
      "SK SRI LANANG ",
      "SK TAMBAK PAYA ",
      "SK SERI BEMBAN",
      "SMK SULTAN MANSOR SHAH",
      "SK PARIT MELANA",
      "SK SRI LAKSAMANA",
      "SK ASAHAN ",
      "SK TELOK BEREMBANG",
      "SK BUKIT SENGGEH",
      "SEKOLAH KEBANGSAAN SRI LANANG ",
      "SEKOLAH KEBANGSAAN AIR BARUK",
      "SMK TUN TIJAH ",
      "SK (P) DURIAN DAUN MELAKA",
      "SEKOLAH KEBANGSAAN ALAI",
      "SK CHENG",
      "SK FELDA BUKIT SENGGEH ",
      "SK SUNGAI RAMBAI",
      "SK BUKIT BERUANG",
      "SK TANJUNG MINYAK 2",
      "SEKOLAH KEBANGSAAN UJONG PASIR",
      "SJKT MERLIMAU",
      "SK CHABAU",
      "SK DATO DEMANG HUSSIN",
      "SK SERI MENDAPAT",
      "SK CHOHONG ",
      "SJKC MALIM",
      "SJKC TIANG DUA",
      "SEKOLAH JENIS KEBANGSAAN (CINA) TABOH NANING",
      "SEKOLAH KEBANGSAAN PANTAI KUNDOR",
      "SEKOLAH KEBANGSAAN TAMBAK PAYA",
      "SK PARIT PENGHULU",
      "SMK KAMPUNG GELAM MELAKA",
      "SEKOLAH KEBANGSAAN KEM TERENDAK II",
      "SEKOLAH KEBANGSAAN MENGGONG",
      "SEKOLAH KEBANGSAAN OTHMAN SYAWAL",
      "MRSM TUN GHAFAR BABA",
      "SEKOLAH KEBANGSAAN BANDAR HILIR",
      "SEKOLAH KEBANGSAAN TANJUNG MINYAK",
      "SEKOLAH MENENGAH KEBANGSAAN KLEBANG BESAR",
      "SMJK TINGGI CINA MELAKA",
      "SEKOLAH MENENGAH KEBANGSAAN SERI KOTA",
      "SK BERTAM HULU",
    ],
  },
  {
    name: "NEGERI SEMBILAN",
    values: [
      "SEKOLAH MENENGAH KEBANGSAAN RAJA JUMAAT",
      "SK KAMPUNG BARU SI RUSA ",
      "SEKOLAH MENENGAH KEBANGSAAN (FELDA) LUI BARAT",
      "SEKOLAH MENENGAH KEBANGSAAN INTAN PERDANA",
      "SEKOLAH MENENGAH KEBANGSAAN DATO' ABDUL SAMAD",
      "SK WAWASAN SEREMBAN 2",
      "SEKOLAH KEBANGSAAN SENAWANG",
      "SMKA DATO' HAJI ABU HASSAN HAJI SAIL",
      "SMK PANCHOR",
      "SMK KING GEORGE V",
      "SK DESA CEMPAKA ",
      "SEKOLAH KEBANGSAAN SERI PILAH",
      "SK MENDUM",
      "KOLEJ TINGKATAN ENAM FOREST HEIGHTS SEREMBAN",
      "SEKOLAH KEBANGSAAN BATANG BENAR",
      "SK TAMAN SERI PAGI",
      "SK DATO' KLANA PUTRA",
      "SK PULAPAH ",
      "SEKOLAH MENENGAH KEBANGSAAN UNDANG REMBAU",
      "SEKOLAH KEBANGSAAN LONDAH",
      "SK DATUK AKHIR ZAMAN",
      "SEKOLAH KEBANGSAAN PANCHOR",
      "SEKOLAH MENENGAH KEBANGSAAN DATO' MOHD TAHA",
      "SEKOLAH KEBANGSAAN TERIANG",
      "SEKOLAH KEBANGSAAN KAMPONG GELAM",
      "SEKOLAH MENENGAH KEBANGSAAN SEREMBAN 3",
      "SEKOLAH JENIS KEBANGSAAN (CINA) CHUAH",
      "KOLEJ TUNKU KURSHIAH",
      "SJKC PEI HUA",
      "SEKOLAH MENENGAH SAINS REMBAU",
      "SEKOLAH KEBANGSAAN (FELDA) LUI MUDA",
      "SK TITIAN BINTANGOR",
      "SEKOLAH KEBANGSAAN SEREMBAN 2A",
      "SEKOLAH MENENGAH KEBANGSAAN JELAI",
      "SMK BANDAR BARU SRI SENDAYAN",
      "SEKOLAH MENENGAH KEBANGSAAN AGAMA SHEIKH HJ MOHD SAID",
      "SEKOLAH MENENGAH AGAMA CHUAH",
      "SEKOLAH KEBANGSAAN BANDAR SRI SENDAYAN",
      "SEKOLAH KEBANGSAAN PANGLIMA ADNAN",
      "SMK BATU KIKIR (MODEL KHAS)",
      "SEKOLAH KEBANGSAAN PORT DICKSON",
      "SEKOLAH KEBANGSAAN MENDUM",
      "SK INTAN PERDANA ",
      "SK AYER HITAM",
      "SMK BUKIT KEPAYANG",
      "SEKOLAH KEBANGSAAN (FELDA) SERTING",
      "SK SUNGAI LUI",
      "SK PALONG 8 (F)",
      "SEKOLAH MENENGAH KEBANGSAAN DATUK HAJI ABDUL SAMAD",
      "SEKOLAH MENENGAH AGAMA ULU JEMPOL",
      "SMK BATU KIKIR(MODEL KHAS)",
      "SEKOLAH KEBANGSAAN SERTING ILIR",
      "SEKOLAH KEBANGSAAN JELAI 3 (FELDA)",
      "SEKOLAH KEBANGSAAN SALAK NAMA",
      "SJKT LORONG JAVA",
      "SMK (F) LUI BARAT",
      "SEKOLAH KEBANGSAAN (FELDA) PALONG 9",
      "SEKOLAH KEBANGSAAN TAMAN RASAH JAYA",
      "SEKOLAH MENENGAH KEBANGSAAN CHAN WA",
      "SEKOLAH KEBANGSAAN DATO' AHMAD MANAF",
      "SJKC LADANG SILIAU ",
      "SMK PUTERI",
      "SEKOLAH KEBANGSAAN LUKUT",
      "SK PASIR PANJANG",
      "SMKA DATO HAJI ABU HASSAN HAJI SAIL",
      "SMK TANAH MERAH",
      "SEKOLAH KEBANGSAAN BUKIT ROKAN UTARA (F) ",
      "SEKOLAH MENENGAH AGAMA TELOK KEMANG",
      "SEKOLAH KEBANGSAAN KING GEORGE V",
      "SMT TUANKU JAAFAR",
      "SEKOLAH KEBANGSAAN SERTING ULU",
      "SEKOLAH MENENGAH SAINS TUANKU MUNAWIR",
      "SMK TAMAN TUANKU JAAFAR",
      "SEKOLAH KEBANGSAAN TELOK KEMANG",
      "SEKOLAH MENENGAH KEBANGSAAN PASIR PANJANG",
      "SEKOLAH KEBANGSAAN JIMAH BARU",
      "SJKC CHUAH",
      "SEKOLAH MENENGAH KEBANGSAAN SERI PAGI",
      "SK KOMPLEKS KLIA ",
      "SEKOLAH MENENGAH KEBANGSAAN ST PAUL",
      "SEKOLAH MENENGAH SAINS TUANKU JAAFAR",
      "SEKOLAH KEBANGSAAN UNDANG REMBAU",
      "SMK DATUK MANSOR",
      "SEKOLAH KEBANGSAAN NILAI IMPIAN",
      "SJKT TUN SAMBANTHAN PAJAM",
      "SK KAMPUNG BARU SI RUSA",
      "SMK BUKIT SAUJANA",
      "SEKOLAH KEBANGSAAN (FELDA) PALONG 4",
      "SEKOLAH KEBANGSAAN KERU",
      "SMK TUNKU KURSHIAH",
      "SK PORT DICKSON",
      "SEKOLAH MENENGAH KEBANGSAAN NILAI IMPIAN",
      "SEKOLAH KEBANGSAAN TUNKU KURSHIAH",
      "SEKOLAH KEBANGSAAN (FELDA) BUKIT JALOR",
      "SMA DATO' HAJI MUSTAFA ",
    ],
  },
];

const SABAH_STATES = [
  {
    name: "SABAH",
    values: [
      "SMK ST.MARY LIMBAHAU PAPAR",
      "SEKOLAH JENIS KEBANGSAAN (CINA) KUOK MING",
      "SMK BUKIT GARAM ",
      "SMJK SHAN TAO",
      "SMK BUKIT GARAM II",
      "SJKC ST JAMES ",
      "SJKC CHEN SIN TUARAN",
      "SK LOK YUK LIKAS",
      "SMK LIMBANAK",
      "SK TUDAN",
      "SM ST JOHN",
      "SMK SEPULOT",
      "SEK KEB TOBOBON ",
      "SMK SANDAKAN II",
      "SMK PEREMPUAN SANDAKAN",
      "SM LOK YUK KOTA KINABALU (CF)",
      "SMK LIMBANAK PENAMPANG ",
      "SEKOLAH KEBANGSAAN KOTA KINABATANGAN",
      "SM SUNG SIEW (cCF)",
      "SEKOLAH KEBANGSAAN (CINA) ANGLO-CHINESE",
      "SMK NABAWAN 2",
      "SEKOLAH MENENGAH KEBANGSAAN SANDAKAN DUA",
      "SJKC CHEN SIN ",
      "KOLEJ VOKASIONAL LIKAS",
      "SMKLIMBANAK",
      "SK KILIMU",
      "KOLEJ VOKASIONAL BEAUFORT",
      "SMK ST PATRICK MEMBAKUT",
      "SK SUKAU",
      "MAKTAB NASIONAL",
      "SEKOLAH MENENGAH KEBANGSAAN LOK YUK LIKAS",
      "SJKC ST JAMES",
      "SMK KUHARA",
      "SEKOLAH MENENGAH TSHUNG TSIN SABAH",
    ],
  },
  {
    name: "WILAYAH PERSEKUTUAN LABUAN",
    values: ["SMK ST ANNE", "SK. LAYANG-LAYANGAN", "SMK MUTIARA", "SK BUKIT KALLAM", "SK TANJUNG ARU ", "SMK PANTAI"],
  },
];

const SARAWAK_STATES = [
  {
    name: "SARAWAK",
    values: [
      "SEKOLAH MENENGAH KEBANGSAAN TIONG HIN",
      "SMK MERBAU",
      "SJKC EK HUA",
      "SEKOLAH JENIS KEBANGSAAN (CINA) CHUNG HUA NO. 5",
      "SJK CHUNG HUA",
      "SEKOLAH KEBANGSAAN SEBAKO",
      "SEKOLAH MENENGAH KEBANGSAAN SG MAONG",
      "SK LUMBA KUDA",
      "SMK LANANG ",
      "KOLEJ VOKASIONAL BETONG",
      "SMK DPHA GAPOR",
      "SMK BAKO",
      "SMK AGAMA SIBU",
      "SMK SAINT LUKE",
      "SJKC CHONG BOON MUKAH",
      "SEKOLAH MENENGAH KEBANGSAAN THREE RIVERS",
      "SMK ROSLI DHOBY SIBU",
      "SK MUNGGU LALLANG",
      "SMK ENGKILILI",
      "SEKOLAH MENENGAH KEBANGSAAN KIDURONG",
      "SMK AGAMA TUN AHMAD ZAIDI",
      "SK RAKYAT",
      "SMK MUKAH",
      "SMK ROSLI DHOBY",
      "SK MUNGGU LALLANG SIMUNJAN",
      "SJK CHUNG HUA PENDING",
      "SEKOLAH JENIS KEBANGSAAN (CINA) KWANG CHIEN",
      "SMK BANDAR KUCHING NO.1",
      "SK SUNGAI DUAN",
      "SEKOLAH MENENGAH KEBANGSAAN MEDAMIT",
      "SJK CHUNG HUA BATU 4.5",
      "SMK METHODIST SIBU",
      "SEKOLAH KEBANGSAAN MELAYU PUSAT",
      "SEKOLAH KEBANGSAAN BATU BUNGAN",
      "SMK TUNG HUA",
      "SK ABANG KADIR GEDONG",
      "SMK TINGGI KUCHING",
      "SEKOLAH MENENGAH KEBANGSAAN ST. ELIZABETH ",
    ],
  },
];

export const REGION_DATA = [
  {name: "UTARA", values: UTARA_STATES},
  {name: "TENGAH", values: TENGAH_STATES},
  {name: "TIMUR", values: TIMUR_STATES},
  {name: "SELATAN", values: SELATAN_STATES},
  {name: "SABAH", values: SABAH_STATES},
  {name: "SARAWAK", values: SARAWAK_STATES},
];
